import './FilterPanel.css';

import React, { useCallback } from 'react';
import { Button } from '@vtblife/uikit';
import { Size } from '@vtblife/uikit/legacy';

import { errorCatcherWrap } from '@search/error/src/catcher';
import classname from '@search/classname/src';

import { RegionIdEnum } from '@search/filter-enums/enums/Region';
import { RootRegionsApplicationEnum } from '@search/graphql-typings';
/* eslint-disable complexity */
import { GeoBaseStore } from '@search/vtbeco-frontend-core/domain/geo/GeoBase';
import { ClassifiedFilterCollection } from '@search/vtbeco-frontend-core/domain/offer/filters/ClassifiedFilterCollection';
import {
    AddQueryDisplayValue, ExtendedTip, QueryDisplayValue
} from '@search/vtbeco-frontend-core/view/common/hooks/useQueryDisplayValues';

import { Filters, IFilter } from '@search/vtbeco-frontend-core/view/filters/models/Filter';
import { DesktopGeoFiltersView2 } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/desktop/geo/DesktopGeoFiltersView2';
import { formatNumber } from '@search/helpers/src/formatNumber';
import { useButtonsVisible } from '@search/vtbeco-frontend-core/view/common/components/CommonSearchFilterPanel/useButtonsVisible';
import { RealtyObjectType } from '@search/filter-enums/enums';
import { CommonSearchFilterPanel } from '@search/vtbeco-frontend-core/view/common/components/CommonSearchFilterPanel/CommonSearchFilterPanel';
import { SellTypeSelectFilterView } from '@search/vtbeco-frontend-core/view/filters/components/filter_types/sell_type/SellTypeSelectFilter';
// import { ClPromoRieltorsTrigger } from '@search/classified-common/src/ClPromoRieltorsTrigger/ClPromoRieltorsTrigger';

const cn = classname.bind(null, 'FilterPanel');

export interface FilterPanelProps {
    geoStore: GeoBaseStore;
    count: number;
    filters: ClassifiedFilterCollection;
    removeDrawArea?: () => void;
    addQueryDisplayValue?: AddQueryDisplayValue;
    regionUpdated: (region: RegionIdEnum) => void;
    updateFilters: (filters: ClassifiedFilterCollection) => void;
    handleSubmit?: (filters: Map<Filters, IFilter>) => void;

    removeTips: (tips: ExtendedTip[]) => void;
    tips?: QueryDisplayValue[];
    loading?: boolean;
    showPromoRieltors: boolean;
}

export const FilterPanel = errorCatcherWrap(function FilterPanel({
    geoStore,
    count,
    loading,
    filters,
    removeTips,
    regionUpdated,
    updateFilters,
    handleSubmit,
    tips,
    addQueryDisplayValue,
    removeDrawArea,
    // showPromoRieltors
}: FilterPanelProps) {
    const { isButtonsVisible } = useButtonsVisible();

    const onSubmit = useCallback(() => {
        handleSubmit && handleSubmit(filters.getFilters());
    }, [ filters, handleSubmit ]);

    const countOffers = count > 0 ? `Показать ${(count > 0) ? formatNumber(count) : ''}` : 'Нет предложений';

    if (! filters) {
        return null;
    }

    return (
        <CommonSearchFilterPanel
            removeDrawArea={removeDrawArea}
            filters={filters}
            className={cn()}
            regionUpdated={regionUpdated}
            updateFilters={updateFilters}
            renderGeoFilter={updateFewFilters => (
                <DesktopGeoFiltersView2
                    showNewBuildingsGroup={filters.getCategoryTypeFilter().categoryType === RealtyObjectType.FLAT}
                    placeholder='Метро, район, адрес, ЖК'
                    placeholderWithNewBuildings='Метро, район, адрес, ЖК'
                    isVertical
                    inputSize={Size.Small}
                    geoStore={geoStore}
                    count={count}
                    filters={filters}
                    onChange={updateFewFilters}
                    rootRegionsApp={RootRegionsApplicationEnum.OffersSerp}
                    addQueryDisplayValue={addQueryDisplayValue}
                    tips={tips}
                    removeTips={removeTips}
                    clMap
                />
            )}
            renderSellTypeFilter={updateFilter => (
                <SellTypeSelectFilterView
                    filter={filters.get(Filters.sellType)}
                    isRoom={filters.getCategoryTypeFilter().categoryType === RealtyObjectType.ROOM}
                    handleChange={updateFilter}
                    isSecond={filters.isOnlySecond()}
                />
            )}
            // renderDividerContent={showPromoRieltors && (
            //     <ClPromoRieltorsTrigger
            //         regionId={filters.getRegionFilter().region}
            //         isMobile
            //         view='filters-save-search'
            //     />
            // )}
        >
            <div className={cn('buttons', { visible: isButtonsVisible })}>
                <Button
                    fullWidth
                    onClick={onSubmit}
                    disabled={loading}
                    dataTest='filter-submit'
                    loading={loading}
                >
                    {countOffers}
                </Button>
            </div>
        </CommonSearchFilterPanel>
    );
});
